import React from 'react';
import { css } from '@emotion/css';
import { Form, Input, Button, notification } from 'antd';
import { useNavigate } from 'react-router';
import { Helmet } from 'react-helmet-async';
import { ReactComponent as Logo } from '@/assets/img/logo_w.svg';
import useAuthPasswordResetMutation from '@/hooks/useAuthPasswordResetMutation';
import { formItemValidateMessage, formItemValidateStatus } from '@/utils/form';

const wrapperStyle = css`
  margin: 0 auto;
  width: 100%;
  height: 100vh;
  background: transparent
    linear-gradient(171deg, #37c8d6 0%, #26b4de 51%, #39fef4 100%) 0% 0%
    no-repeat padding-box;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

const blockStyle = css`
  max-width: 510px;
  width: 100%;
  margin: auto;
  text-align: center;
`;

const logoStyle = css`
  display: block;
  max-width: 312px;
  margin: 0 auto 70px;
  max-width: 100%;
`;

const inputStyle = css`
  padding: 20px 24px;
`;

const authPasswordResetFormItemStyle = css`
  position: relative;

  &.ant-form-item-has-error {
    .ant-input {
      background-color: #f5dede;
    }
  }

  &.ant-form-item-with-help {
    margin-bottom: 24px;
  }
  .ant-form-item-explain-error {
    position: absolute;
    top: 50%;
    left: calc(100% + 20px);
    transform: translateY(-50%);
    text-align: left;
    color: #fff;
    font-size: 11px;
    width: 100%;
    max-width: 106px;
  }
`;

type AuthPasswordResetFormValues = {
  email: string;
};

const authPasswordResetFormInitialValues: AuthPasswordResetFormValues = {
  email: '',
};

const PasswordReset: React.FC = () => {
  const navigate = useNavigate();
  const authPasswordResetMutation = useAuthPasswordResetMutation();
  const handleAuthPasswordReset = (values: AuthPasswordResetFormValues) => {
    authPasswordResetMutation.mutate(
      {
        email: values.email,
      },
      {
        async onSuccess() {
          navigate('/passwordReset/complete');
        },
        onError() {
          notification.error({
            message: 'メール送信に失敗しました。',
          });
        },
      }
    );
  };
  return (
    <>
      <Helmet>
        <title>パスワードリセット</title>
      </Helmet>
      <div className={wrapperStyle}>
        <div className={blockStyle}>
          <Logo className={logoStyle} />
          <Form<AuthPasswordResetFormValues>
            name="login"
            initialValues={authPasswordResetFormInitialValues}
            onFinish={handleAuthPasswordReset}
          >
            <Form.Item
              name="email"
              className={authPasswordResetFormItemStyle}
              validateStatus={formItemValidateStatus(
                authPasswordResetMutation.error,
                'email'
              )}
              help={formItemValidateMessage(
                authPasswordResetMutation.error,
                'email'
              )}
            >
              <Input
                type="email"
                placeholder="メールアドレス ※半角英数で入力してください"
                className={inputStyle}
              />
            </Form.Item>
            <span className="text-sm inline-block text-white mb-5">
              登録したアカウントのメールアドレスに再設定したパスワードを送信します。
            </span>
            <Form.Item>
              <Button
                htmlType="submit"
                shape="round"
                className="button-green"
                style={{
                  width: '100%',
                  maxWidth: '186px',
                  padding: '10px 16px',
                  height: 'auto',
                }}
              >
                メールを送信
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
};

export default PasswordReset;
